module.exports = __webpack_public_path__ + "img/p4.01d78034.png";